import { useEffect, useState } from "react";
import API from "../../api/api";
import Modal from "../../components/Modal";
import Toast from "../../components/Toast";

const IMG_BASE = "https://cmsapi.mks.org.au/uploads/";

function SponsorsList() {
    const [list, setList] = useState([]);
    const [tiers, setTiers] = useState([]);
    const [loading, setLoading] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [formData, setFormData] = useState({
        name: "",
        tierId: "",
        websiteUrl: "",
        logo: null
    });
    const [toast, setToast] = useState(null);

    const loadData = async () => {
        setLoading(true);
        console.log("Loading sponsors and sponsor tiers...");
        try {
            const [sponsorsRes, tiersRes] = await Promise.all([
                API.get("/sponsors"),
                API.get("/sponsor-tiers")
            ]);
            console.log("Sponsors received:", sponsorsRes.data);
            console.log("Sponsor Tiers received:", tiersRes.data);
            setList(sponsorsRes.data);
            setTiers(tiersRes.data);
            if (tiersRes.data.length > 0 && !formData.tierId) {
                setFormData(prev => ({ ...prev, tierId: tiersRes.data[0].TierId }));
            }
        } catch (err) {
            console.error("Error loading sponsors data:", err);
            console.error("Error details:", err.response?.data || err.message);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        loadData();
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const data = new FormData();
            if (formData.logo) data.append("logo", formData.logo);

            const params = new URLSearchParams({
                name: formData.name,
                tierId: formData.tierId,
                websiteUrl: formData.websiteUrl
            }).toString();

            await API.post(`/sponsors?${params}`, data, {
                headers: { "Content-Type": "multipart/form-data" }
            });

            showToast("Sponsor added successfully");
            setIsModalOpen(false);
            loadData();
            setFormData({ name: "", tierId: tiers[0]?.TierId || "", websiteUrl: "", logo: null });
        } catch (err) {
            showToast("Error adding sponsor", "error");
        }
    };

    const handleDelete = async (id) => {
        if (window.confirm("Are you sure you want to delete this sponsor?")) {
            try {
                await API.delete(`/sponsors/${id}`);
                showToast("Sponsor deleted successfully");
                loadData();
            } catch (err) {
                showToast("Error deleting sponsor", "error");
            }
        }
    };

    const showToast = (message, type = "success") => {
        setToast({ message, type });
    };

    return (
        <div className="admin-card">
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "20px" }}>
                <h2 style={{ margin: 0 }}>Sponsors</h2>
                <button className="btn btn-primary" onClick={() => setIsModalOpen(true)}>+ Add Sponsor</button>
            </div>

            {loading ? (
                <p>Loading sponsors...</p>
            ) : (
                <table className="admin-table">
                    <thead>
                        <tr>
                            <th>Logo</th>
                            <th>Name</th>
                            <th>Tier</th>
                            <th>Website</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {list.map(x => (
                            <tr key={x.SponsorId}>
                                <td>
                                    <img
                                        src={x.LogoFile ? (x.LogoFile.startsWith('http') ? x.LogoFile : IMG_BASE + x.LogoFile) : "https://via.assets.so/img.jpg?w=60&h=40&tc=white&bg=#ccd1d9&t=LOGO"}
                                        style={{ width: "60px", height: "40px", borderRadius: "4px", objectFit: "contain", background: "#f8fafc" }}
                                        alt={x.Name}
                                    />
                                </td>
                                <td><strong>{x.Name}</strong></td>
                                <td><span className="badge badge-success" style={{ background: "#e0f2fe", color: "#0369a1" }}>{x.TierName}</span></td>
                                <td>
                                    {x.WebsiteUrl ? (
                                        <a href={x.WebsiteUrl.startsWith('http') ? x.WebsiteUrl : `https://${x.WebsiteUrl}`} target="_blank" rel="noreferrer" style={{ color: "var(--primary)" }}>
                                            {x.WebsiteUrl}
                                        </a>
                                    ) : 'N/A'}
                                </td>
                                <td>
                                    <button className="btn btn-outline" onClick={() => handleDelete(x.SponsorId)} style={{ padding: "4px 8px", color: "var(--danger)" }}>Delete</button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}

            <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} title="Add New Sponsor">
                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label>Sponsor Name</label>
                        <input className="form-control" value={formData.name} onChange={e => setFormData({ ...formData, name: e.target.value })} required />
                    </div>
                    <div className="form-group">
                        <label>Tier</label>
                        <select className="form-control" value={formData.tierId} onChange={e => setFormData({ ...formData, tierId: e.target.value })} required>
                            {tiers.map(t => (
                                <option key={t.TierId} value={t.TierId}>{t.TierName}</option>
                            ))}
                        </select>
                    </div>
                    <div className="form-group">
                        <label>Website URL</label>
                        <input className="form-control" placeholder="www.example.com" value={formData.websiteUrl} onChange={e => setFormData({ ...formData, websiteUrl: e.target.value })} />
                    </div>
                    <div className="form-group">
                        <label>Logo</label>
                        <input type="file" className="form-control" onChange={e => setFormData({ ...formData, logo: e.target.files[0] })} required />
                    </div>
                    <div style={{ marginTop: "20px", display: "flex", justifyContent: "flex-end" }}>
                        <button type="button" className="btn btn-outline" onClick={() => setIsModalOpen(false)} style={{ marginRight: "10px" }}>Cancel</button>
                        <button type="submit" className="btn btn-primary">Add Sponsor</button>
                    </div>
                </form>
            </Modal>

            {toast && <Toast message={toast.message} type={toast.type} onClose={() => setToast(null)} />}
        </div>
    );
}

export default SponsorsList;
